// =============================================================================
// Browser Polyfills
// =============================================================================
// Must be imported FIRST in main.tsx (before any library code).
//
// URL.parse: Added in Safari 18 (Sept 2024) / Chrome 126 (June 2024).
// pdfjs-dist 5.x uses URL.parse() internally, which crashes on older browsers
// with "TypeError: URL.parse is not a function".
// Spec: https://url.spec.whatwg.org/#dom-url-parse
// =============================================================================

if (typeof (URL as any).parse !== 'function') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (URL as any).parse = function (url: string, base?: string) {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}
